module.exports = __webpack_public_path__ + "img/Alternatives-Alternatives scoping.88e7d60a.svg";